//Admin/ReportCriteria/Set/{AuthToken}/
import React from 'react'
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash"
import { Grid, Typography, Box, TextField } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { reportcriteriaModify, selectReportCriteriaEntities } from '../../../reducers/admincenter_reportcriteria';


/**
 * 
{
"ReportCriteria":
{
"ReportGuid": "97069626-6A92-4BA5-AC4B-B47969B454D9",
"SelectedAssessmentProduct": "HRA200",
"ParticipantGuid": "5FEA08D8-4F8B-4CF8-957A-2EC1FE8B36ED",
"AssessmentGuid": "C83D7CEE-1870-467B-953A-E414006D5C57",
"ReportOutputFormat": "XML",
"FirstRowHeader": "1",
"ReportGroupName": "Arbitrary Name Passed By Caller",
"IncludeAdditionalQuestions": "1",
"ExcludeInactiveParticipants": "0",
"DateRangeStart": "2015-01-01",
"DateRangeEnd": "2016-12-31",
"HRAStartedInDateRange": "0",
"HRANotStartedInDateRange": "0",
"HRACompletedInDateRange": "1",
"HRANotCompletedInDateRange": "0",
"GroupGuidList":["6C096600-B754-49A0-A72D-23CC85548FC7","032AAA24-4222-4FD2-AC42-2F690FCCE860","6F8E2BCC-AC19-4353-B245-A6F74DE7F7E1","45642721-13D9-4A15-9220-F8B4CF11B3A6","5DED27D7-D094-4295-800F-3CE85B3B4AF5","9EE86F41-5A96-4984-A4BE-DD93FD893B7A","5E4AB781-A30A-4D47-9751-C0D453505AEF","4C1C8A83-F70F-44A4-BEDB-966D16389367","D7D6843F-DD37-4464-9B75-22D872304B24","0CD7527D-5D34-4176-AACE-F404BF825FFF"]
}'
 */
const ReportCriteriaDates = (props) => {
    const dispatch = useDispatch()

    const { user: currentUser } = useSelector((state) => state.auth);

    const ReportCriteria = useSelector(state => selectReportCriteriaEntities(state))

    const handleModifyLocal = (k, v) => {
        dispatch(reportcriteriaModify({ Key: k, Value: v }))

    }

    return (

        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={3}>

            <Grid item xs={2}>
                <Box justifyContent="right">
                    <Typography variant="body1">From</Typography>
                </Box>
            </Grid>
            <Grid item xs={4}>
                <Box justifyContent="left">
                    <TextField variant="standard" type="date" placeholder='From' value={ReportCriteria.DateRangeStart} onChange={(e, nv) => { handleModifyLocal("DateRangeStart", e.target.value) }} />
                </Box>
            </Grid>
            <Grid item xs={2}>
                <Box justifyContent="right">
                    <Typography variant="body1">To</Typography>
                </Box>
            </Grid>
            <Grid item xs={4}>
                <Box justifyContent="left">
                    <TextField variant="standard" type="date" placeholder='To' value={ReportCriteria.DateRangeEnd} onChange={(e, nv) => { handleModifyLocal("DateRangeEnd", e.target.value) }} />
                </Box>
            </Grid>

        </Grid>
    )

}
export default ReportCriteriaDates
